import React, { Component, Fragment, forwardRef } from 'react';
import DatePicker, { registerLocale, CalendarContainer } from 'react-datepicker';
import InputWrap from './InputWrap';
import Collapsible from "react-collapsible";
import {collapsibleSettings} from "../../helpers/Helpers";
import {classNamesPrefixed} from "../../../helpers/CoreHelpers";
import "react-datepicker/dist/react-datepicker.css";
import { Icon } from "../UI/Icon";
import enGb from 'date-fns/locale/en-GB';
import SelectField from './SelectField';
import moment from 'moment'

//Fix to start with monday
registerLocale('en-gb', enGb);

const CustomInput = forwardRef(({ onClick, value }, ref) => (
    <span
        className={classNamesPrefixed({ "custom-date-input": true })}
        onClick={onClick}
    >
        <input
            type={"text"}
            value={value}
            readOnly={true}
        />
        <Icon name={"calendar-alt"} />
    </span>
))

class DatePickerField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentDate: new Date(),
            newDate: new Date(),
            hours: 0,
            minutes: 0
        }

        this.inputRef = React.createRef();
    }

    getHours() {
        let hours = [];

        for (let i = 0; i < 24; i++) {
            hours.push({
                id: i,
                title: i < 10 ? ('0' + i) : i
            });
        }

        return hours;
    }

    getMinutes() {
        let minutes = [];

        for (let i = 0; i < 60; i++) {
            minutes.push({
                id: i,
                title: i < 10 ? ('0' + i) : i
            });
        }

        return minutes;
    }

    CustomContainer = ({ className, children }) => {
        return (
            <div>
                <CalendarContainer className={className}>
                    <div style={{ position: "relative", zIndex: "999" }}>{children}</div>
                    <div className={"calendar-custom-wrapper"}>
                        <div className={"time-select"}>
                            <SelectField
                                items={this.getHours()}
                                input={{ value: this.state.hours }}
                                afterOnChange={(value) => this.changeHours(value)}
                                defaultValue={{
                                    id: 0,
                                    title: '00'
                                }}
                                omitCollapsible={true}
                            />
                            :
                            <SelectField
                                items={this.getMinutes()}
                                input={{ value: this.state.minutes }}
                                afterOnChange={(value) => this.changeMinutes(value)}
                                defaultValue={{
                                    id: 0,
                                    title: '00'
                                }}
                                omitCollapsible={true}
                            />
                        </div>
                        <div className={"calendar-buttons"}>
                            <button
                                className={classNamesPrefixed({
                                    "btn": true,
                                    "btn--primary": true
                                })}
                                type={"button"}
                                onClick={() => this.setNewDate()}>
                                Ok
                            </button>
                            <button
                                className={classNamesPrefixed({
                                    "btn": true,
                                    "btn--secondary": true
                                })}
                                type={"button"}
                                onClick={() => this.calendarRef.setOpen(false)}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </CalendarContainer>
            </div>
        );
    };

    componentDidMount() {
        const { input } = this.props;

        const date = input && input.value ? new Date(input.value) : new Date();
        const localDate = new Date(date.toString() + (input && input.value ? " UTC" : ""));

        const time = localDate.getTime();

        this.setState({
            currentDate: new Date(time),
            newDate: new Date(time),
            hours: localDate.getHours(),
            minutes: localDate.getMinutes()
        });

        if (!input.value) {
            this.props.input.onChange(moment.utc(new Date(time).getTime()).format());
        }
    }

    handleDateChange(date) {
        this.setState({
            newDate: date
        });
    }

    setNewDate() {
        this.setState({
            currentDate: new Date(this.state.newDate.getTime())
        });

        this.calendarRef.setOpen(false);

        this.props.input.onChange(moment.utc(this.state.newDate.getTime()).format());
        console.log(new Date(this.state.newDate.getTime()));

    }

    changeHours(hours) {
        this.setState(({
            hours: hours,
            newDate: new Date(this.state.newDate.setHours(hours))
        }));
    }

    changeMinutes(minutes) {
        this.setState(({
            minutes: minutes,
            newDate: new Date(this.state.newDate.setMinutes(minutes))
        }));
    }

    compareDates(firstDate, secondDate) {
        return firstDate.setHours(0, 0, 0, 0) === secondDate.setHours(0, 0, 0, 0)
    }

    render() {
        const {
            label,
            omitCollapsible,
            expanded,
            name
        } = this.props;

        let inputWrapProps = {
            ...this.props,
            error: this.props && this.props.meta && this.props.meta.error ? this.props.meta.error : false,
            type: "date",
        };

        const content = (
            <InputWrap {...inputWrapProps} classes="field--relative">
                <DatePicker
                    ref={(r) => {
                        this.calendarRef = r;
                    }}
                    selected={this.state.currentDate}
                    onChange={date => this.handleDateChange(new Date(date))}
                    customInput={<CustomInput ref={this.inputRef} />}
                    dateFormat="yyyy-MM-d, HH:mm"
                    locale="en-gb"
                    key={name}
                    calendarClassName={classNamesPrefixed({ "custom-date-picker": true })}
                    shouldCloseOnSelect={false}
                    dayClassName={date =>
                        this.compareDates(new Date(date.getTime()), new Date(this.state.currentDate.getTime())) ? "current-selected" :
                            this.compareDates(new Date(date.getTime()), new Date(this.state.newDate.getTime())) ? "new-selected" : undefined
                    }
                    calendarContainer={this.CustomContainer}
                    popperPlacement="top-end"
                />
            </InputWrap>
        )

        return (
            <Fragment>
                {omitCollapsible ? (
                    <div>{content}</div>
                ) : (
                    <Collapsible
                        {...collapsibleSettings}
                        trigger={<label className={classNamesPrefixed({"trigger__label":true})}>{label ? label : 'Date field'}</label>}
                        open={expanded}
                    >
                        {content}
                    </Collapsible>
                )}
            </Fragment>
        );
    }
};

export default DatePickerField;



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/DatePickerField.js